import { type ReactNode } from 'react'
import { isDefined, type Preference, type PreferenceInheritOutput } from '@terros/common'
import { Tooltip } from '@mantine/core'
import { useQueryDisclosure } from '@hooks'
import { useTranslation } from '@front/model'
import { TButton } from '../buttons'
import { AuditDrawer } from '../auditInfo'

type Props = {
  data: PreferenceInheritOutput<Preference>
  preferenceId: Preference
}

export const HistoryButton = ({ data, preferenceId }: Props): ReactNode => {
  const { t } = useTranslation()
  const [opened, { open, close }] = useQueryDisclosure(preferenceId, false)

  const hasHistory = isDefined(data.scopeId)

  return (
    <>
      <Tooltip label={hasHistory ? t('History') : t('No edit history')}>
        <TButton
          buttonType='icon-rounded'
          icon='history'
          variant='secondary'
          onClick={open}
          disabled={!hasHistory}
        />
      </Tooltip>
      <AuditDrawer close={close} opened={opened} {...data} />
    </>
  )
}
